module.exports = __webpack_public_path__ + "img/0910f_2.a0b85b20.jpg";